var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 10C15.25 9.58579 14.9142 9.25 14.5 9.25C14.0858 9.25 13.75 9.58579 13.75 10L15.25 10ZM3.25 10C3.25 9.58579 2.91421 9.25 2.5 9.25C2.08579 9.25 1.75 9.58579 1.75 10L3.25 10ZM13.75 10L13.75 12L15.25 12L15.25 10L13.75 10ZM12.5 13.25L4.5 13.25L4.5 14.75L12.5 14.75L12.5 13.25ZM3.25 12L3.25 10L1.75 10L1.75 12L3.25 12ZM4.5 13.25C3.80964 13.25 3.25 12.6904 3.25 12L1.75 12C1.75 13.5188 2.98122 14.75 4.5 14.75L4.5 13.25ZM13.75 12C13.75 12.6904 13.1904 13.25 12.5 13.25L12.5 14.75C14.0188 14.75 15.25 13.5188 15.25 12L13.75 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2C9.25 1.58579 8.91421 1.25 8.5 1.25C8.08579 1.25 7.75 1.58579 7.75 2L9.25 2ZM8.5 10L7.96967 10.5303C8.26256 10.8232 8.73744 10.8232 9.03033 10.5303L8.5 10ZM12.0303 7.53033C12.3232 7.23744 12.3232 6.76256 12.0303 6.46967C11.7374 6.17678 11.2626 6.17678 10.9697 6.46967L12.0303 7.53033ZM6.03033 6.46967C5.73744 6.17678 5.26256 6.17678 4.96967 6.46967C4.67678 6.76256 4.67678 7.23744 4.96967 7.53033L6.03033 6.46967ZM7.75 2L7.75 10L9.25 10L9.25 2L7.75 2ZM9.03033 10.5303L12.0303 7.53033L10.9697 6.46967L7.96967 9.46967L9.03033 10.5303ZM9.03033 9.46967L6.03033 6.46967L4.96967 7.53033L7.96967 10.5303L9.03033 9.46967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2ae3fedd84c31bce14f8383195ed5eb4.svg";
export { ForwardRef as ReactComponent };